import React from 'react';

export default function IconSelectionFilere({filiereInfo, getMainActifNum, setMainActifNum, setNumberFiliereActif, data, Lang, recordNav, submitted}) {



    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */ 



    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */ 

    

    /* --- INCRÉMENTE LE NUMÉRO DU SOUS-CRITÈRE ACTIF --- */


    let handleClickFilieresToCriteres = (int) => {
        if (recordNav) {
            recordNav();
        }
        setNumberFiliereActif(int-1);
        if(data.data[int-1].soumis) {
            setMainActifNum(4);
        } else {
            setMainActifNum(getMainActifNum + 1);
        }
    }



    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */ 



    //Si aucun accès n'est donné
    if(filiereInfo.id===-1){
       return (<section className="menuFiliereSsAcces" id={filiereInfo.id}>
        {/*Zone gauche en gris*/}
        <div className="menuFiliereSsAccesLeft">
            <h3 className="menuFilierePeriod"> </h3>
            <h3 className="menuFiliereNiveau"> </h3>
            <h3 className="">{filiereInfo.nom}</h3>
        </div>
    </section>);    
    } else {
    // Candidature : chaque filière (vœu) s'envoie séparément ; une filière
    // transmise reste affichée, les autres restent à compléter.
    const transmise = data?.configuration === 'Candidature' && submitted;
    return (
            <section className={transmise ? "menuFiliere menuFiliere--transmise" : "menuFiliere"} onClick={() => handleClickFilieresToCriteres(filiereInfo.id)} id={filiereInfo.id}>
                {/*Zone gauche en gris*/}
                <div className="menuFiliereLeft">
                    <h3 className="menuFilierePeriod">{filiereInfo.period}</h3>
                    <h3 className="menuFiliereNiveau">{filiereInfo.niveau}</h3>
                    <h3 className="menuFiliereNom">{filiereInfo.nom}</h3>
                </div>
                {/*Le bouton uniquement*/}
                <div className="menuFiliereBoutons">
                    <p>{transmise ? (Lang==="en" ? "Application submitted" : "Candidature transmise") : (Lang==="en" ? "Apply" : "S'inscrire")}</p>
                    <i className="gg-arrow-long-right"></i>
                </div>
            </section>
    );
    }
}
